<template>
	<div v-if="user">
		<!-- SIDEBAR -->
		<div class="menu" :style="{ width: sidebar ? '' : '75px' }">
			<button-collapse-sidebar :open="sidebar" @change="sidebar = !sidebar" />
			<browse-sidebar :open="sidebar" />
		</div>

		<!-- MAIN -->
		<div class="main" :style="{ width: widthscreen, marginLeft: !sidebar ? '75px' : '150px' }">
			<div style="padding: 10px">
				<app-breadcrumb :history="breadcrumb" @mutate="doMutate" />
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import AppBreadcrumb from "@/modules/_common/app-breadcrumb.vue"
import BrowseSidebar from "@/modules/browse/components/sidebar-components/browse-sidebar.vue"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"

export default {
	name: "browse-router",
	components: {
		AppBreadcrumb,
		BrowseSidebar,
		ButtonCollapseSidebar
	},

	data() {
		return {
			sidebar: true || window.innerWidth < 900,
			widthscreen: window.innerWidth - 150,
			heightscreen: window.innerHeight,
			mobile: window.innerWidth < 900
		}
	},
	computed: {
		...mapGetters({
			user: "user/user",
			breadcrumb: "project/breadcrumb"
		})
	},
	methods: {
		...mapActions({
			doMutate: "project/doMutate"
		})
	}
}
</script>

<style scoped>
.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}
</style>
